import axios from "axios"

export function getLooseItemDetail (code) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/inventory/loose-item/detail?code=${code}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};